import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  configSession(data) {
    var url = ConfigAPI.baseURL + "configViewSession" + Session.getToken();

    var params = {
      profile_id: data.profileId,
      selector_session: data.selectorSeccion,
      selector_session_name: data.selectorSeccionName,
    }

    return instance.post(url, params);
  },
  getSessionUser() {
    var url = ConfigAPI.baseURL + "getInfoSession" + Session.getToken();

    return instance.get(url);
  },

  showStaff(id) {
    var url = ConfigAPI.baseURL + "staff/" + id + Session.getToken();
    return instance.get(url);
  },
  showCustomers(id) {
    var url = ConfigAPI.baseURL + "customers/" + id + Session.getToken();
    return instance.get(url);
  },
  showSuppliers(id) {
    var url = ConfigAPI.baseURL + "suppliers/" + id + Session.getToken();
    return instance.get(url);
  }, 
  
  filterCustomersByName(data) {    
    var params = {
      name: data.name
    }
    var url = ConfigAPI.baseURL + "customers/filter/name" + Session.getToken();
    return instance.post(url,params);
  },  
  filterStaffByName(data) {    
    var params = {
      name: data.name
    }
    var url = ConfigAPI.baseURL + "staff/filter/name" + Session.getToken();
    return instance.post(url,params);
  },    
  filterSuppliersByName(data) {    
    var params = {
      name: data.name
    }
    var url = ConfigAPI.baseURL + "suppliers/filter/name" + Session.getToken();
    return instance.post(url,params);
  }, 
  
  getFilterReportLog(data, page) {
    var params = data
    var url = ConfigAPI.baseURL + "reports-log/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url, params);
  },

  getScheduledTasksMonitor() {
    var url = ConfigAPI.baseURL + "system-monitor/scheduled-tasks" + Session.getToken();
    return instance.get(url);
  },
  cleanupScheduledTasksMonitor(data) {
    var url = ConfigAPI.baseURL + "system-monitor/scheduled-tasks/cleanup" + Session.getToken();
    return instance.delete(url, { data: data });
  },
  cleanupFailedJobsMonitor(data) {
    var url = ConfigAPI.baseURL + "system-monitor/failed-jobs/cleanup" + Session.getToken();
    return instance.delete(url, { data: data });
  },

  getUserPreference(key) {
    var url = ConfigAPI.baseURL + "user/preferences/" + key + Session.getToken();
    return instance.get(url);
  },
  saveUserPreference(key, value) {
    var url = ConfigAPI.baseURL + "user/preferences/" + key + Session.getToken();
    var params = {
      value: value
    }
    return instance.post(url, params);
  },
  changePassword(data) {
    var url = ConfigAPI.baseURL + "private/change" + Session.getToken();
    var params = {
      form: data
    }
    return instance.post(url, params);
  },

  getNotificationsUnreadCount() {
    var url = ConfigAPI.baseURL + "notifications/internal/unread-count" + Session.getToken();
    return instance.get(url);
  },
  getNotificationsLast() {
    var url = ConfigAPI.baseURL + "notifications/internal/last" + Session.getToken();
    return instance.get(url);
  },
  markNotificationRead(id) {
    var url = ConfigAPI.baseURL + "notifications/internal/" + id + "/read" + Session.getToken();
    return instance.post(url);
  },
  markAllNotificationsRead() {
    var url = ConfigAPI.baseURL + "notifications/internal/read-all" + Session.getToken();
    return instance.post(url);
  },

  getMessagesConversations() {
    var url = ConfigAPI.baseURL + "messages/conversations" + Session.getToken();
    return instance.get(url);
  },
  getMessagesUnreadCount() {
    var url = ConfigAPI.baseURL + "messages/unread-count" + Session.getToken();
    return instance.get(url);
  },
  startMessagesConversation(staffId) {
    var url = ConfigAPI.baseURL + "messages/conversations" + Session.getToken();
    var params = {
      staff_id: staffId
    }
    return instance.post(url, params);
  },
  getMessages(conversationId) {
    var url = ConfigAPI.baseURL + "messages/conversations/" + conversationId + "/messages" + Session.getToken();
    return instance.get(url);
  },
  sendMessage(conversationId, body) {
    var url = ConfigAPI.baseURL + "messages/conversations/" + conversationId + "/messages" + Session.getToken();
    var params = {
      body: body
    }
    return instance.post(url, params);
  },

  createReminder(data) {
    var url = ConfigAPI.baseURL + "reminders" + Session.getToken();
    return instance.post(url, data);
  }
}

export default servicesAPI;
